import { numberWithSpaces } from '../../../../../../../../../../../tools/Strings/numberWithSpaces';
import { GreyText, IntersectionThDataWrapper, Th, THead } from './styles';
import { useTranslation } from 'react-i18next';
import { IProps } from './interfaces';
import { FC, useContext } from 'react';
import { IntersectionsWithTenantsContext } from '../../../../context';
import { ReportingObjectsTypesMap } from '../../../../constants/constants';

/**
 * Компонент для отображения шапки таблицы
 */
const TableHeader: FC<IProps> = ({ sumValue, days }) => {
    const context = useContext(IntersectionsWithTenantsContext);
    const { t } = useTranslation();
    return (
        <THead>
            <tr>
                <Th>
                    <GreyText>{t(ReportingObjectsTypesMap[context?.selectedReportingObjectsType || ''])}</GreyText>
                </Th>
                <Th>
                    <IntersectionThDataWrapper>
                        <GreyText>{t('Daily average')}</GreyText>
                        {context?.isLoading ? (
                            <GreyText>{t('Loading...')}</GreyText>
                        ) : context?.isError ? (
                            <GreyText>{t('Some error')}</GreyText>
                        ) : (
                            <GreyText>
                                {sumValue !== null ? numberWithSpaces((sumValue / days).toFixed(0)) : '—'}
                            </GreyText>
                        )}
                    </IntersectionThDataWrapper>
                </Th>
                <Th>
                    <IntersectionThDataWrapper>
                        <GreyText>{t('Period')}</GreyText>
                        {context?.isLoading ? (
                            <GreyText>{t('Loading...')}</GreyText>
                        ) : context?.isError ? (
                            <GreyText>{t('Some error')}</GreyText>
                        ) : (
                            <GreyText>{sumValue !== null ? numberWithSpaces(String(sumValue)) : '—'}</GreyText>
                        )}
                    </IntersectionThDataWrapper>
                </Th>
            </tr>
        </THead>
    );
};

export default TableHeader;
